import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Pipeline from "@/pages/Pipeline";
import Catalog from "@/pages/Catalog";
import Simulator from "@/pages/Simulator";
import Quotes from "@/pages/Quotes";
import QuoteEdit from "@/pages/QuoteEdit";
import CustomerDetail from "@/pages/CustomerDetail";
import ForgotPassword from "@/pages/ForgotPassword";
import Settings from "@/pages/Settings";
import BillingSuccess from "@/pages/BillingSuccess";
import VerifyEmail from "@/pages/VerifyEmail";
import PublicProposal from "@/pages/PublicProposal";
import Superadmin from "@/pages/Superadmin";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-solar-bg text-solar-primary font-mono">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function ShellRoute({ children }) {
  return (
    <Protected>
      <AppShell>{children}</AppShell>
    </Protected>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="light" richColors position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ForgotPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/p/:token" element={<PublicProposal />} />
            <Route path="/app" element={<ShellRoute><Dashboard /></ShellRoute>} />
            <Route path="/app/dashboard" element={<ShellRoute><Dashboard /></ShellRoute>} />
            <Route path="/app/customers" element={<ShellRoute><Customers /></ShellRoute>} />
            <Route path="/app/customers/:id" element={<ShellRoute><CustomerDetail /></ShellRoute>} />
            <Route path="/app/pipeline" element={<ShellRoute><Pipeline /></ShellRoute>} />
            <Route path="/app/catalog" element={<ShellRoute><Catalog /></ShellRoute>} />
            <Route path="/app/simulator" element={<ShellRoute><Simulator /></ShellRoute>} />
            <Route path="/app/simulator/:id" element={<ShellRoute><Simulator /></ShellRoute>} />
            <Route path="/app/quotes" element={<ShellRoute><Quotes /></ShellRoute>} />
            <Route path="/app/quotes/:id" element={<ShellRoute><QuoteEdit /></ShellRoute>} />
            <Route path="/app/settings" element={<ShellRoute><Settings /></ShellRoute>} />
            <Route path="/app/billing/success" element={<ShellRoute><BillingSuccess /></ShellRoute>} />
            <Route path="/superadmin" element={<Superadmin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
